import React, { useState, useRef } from "react";
import { 
  ArrowLeft, Utensils, Coffee, FileImage, Camera, Plus, Save, 
  Search, Edit, Trash2, X, Settings, ImagePlus, Download,
  MapPin, ChevronUp, ChevronDown 
} from "lucide-react";
import { supabase } from "../supabaseClient"; 
import CategoryAccordion from "./common/CategoryAccordion";
import { capitalize } from "../utils/helpers";

const AdminPanel = ({
  dishes, setDishes, categories, setCategories, setView, isMobile, styles, t, 
  companyLogo, setCompanyLogo, banquets, halls, setHalls
}) => {
  const [activeMenuType, setActiveMenuType] = useState("banquet");
  
  const [newDish, setNewDish] = useState({ category: "", name: "", weight: "", price: "", image: null });
  const [newCategoryName, setNewCategoryName] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [editingDish, setEditingDish] = useState(null);

  const [newHallName, setNewHallName] = useState("");
  const [showHalls, setShowHalls] = useState(true); 

  //const fileInputRef = useRef(null);
  //const editFileInputRef = useRef(null); 
  const logoInputRef = useRef(null);

  // --- ЛОГИКА ---

  const handlePhotoDisabled = () => {
      alert(t.photoNotAvailable);
  };

  const handleLogoUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    try {
      const fileExt = file.name.split('.').pop();
      const fileName = `logo-${Date.now()}.${fileExt}`;
      const filePath = `${fileName}`;

      // 1. ИСПРАВЛЕНО: было 'companyLogo', стало 'companylogo' (маленькими)
      const { error: uploadError } = await supabase.storage
        .from('companylogo') 
        .upload(filePath, file);

      if (uploadError) throw uploadError;

      // 2. ИСПРАВЛЕНО: было 'companyLogo', стало 'companylogo' (маленькими)
      const { data } = supabase.storage
        .from('companylogo')
        .getPublicUrl(filePath);

      const publicUrl = data.publicUrl;

      // Сохраняем ссылку в базу
      const { error: dbError } = await supabase
        .from('settings')
        .upsert({ id: 1, logo_url: publicUrl });

      if (dbError) throw dbError;

      // Обновляем картинку на экране
      setCompanyLogo(publicUrl); 
      alert("Логотип успешно обновлен!");

    } catch (error) {
      console.error("Ошибка:", error);
      alert("Не удалось загрузить логотип: " + error.message);
    }
  };

  const addHall = async () => { 
    if (!newHallName.trim()) return;
    try {
      const { data, error } = await supabase.from('halls').insert([{ name: newHallName }]).select();
      if (error) throw error;
      setHalls([...halls, data[0]]); 
      setNewHallName("");
    } catch (e) { alert("Ошибка: " + e.message); }
  };

  const deleteHall = async (id, name) => {
    if (banquets && banquets.some(b => b.hall_name === name)) return alert(t.hallInUse || "Зал используется!");
    if (window.confirm(`${t.deleteConfirm} ${name}?`)) {
      const { error } = await supabase.from('halls').delete().eq('id', id);
      if (!error) setHalls(halls.filter(h => h.id !== id));
    }
  };

  const handleAddCategory = async () => {
    if (newCategoryName.trim()) {
      if (categories.some(c => c.name.toLowerCase() === newCategoryName.trim().toLowerCase())) return alert("Категория существует!");
      const { data, error } = await supabase.from('categories').insert([{ name: capitalize(newCategoryName.trim()) }]).select();
      if (!error && data) {
        setCategories([...categories, data[0]]);
        setNewCategoryName("");
      }
    }
  };

  const handleDeleteCategory = async (id, name) => {
     if (window.confirm(`${t.deleteConfirm} ${name}?`)) {
         const { error } = await supabase.from('categories').delete().eq('id', id);
         if (!error) setCategories(categories.filter(c => c.id !== id));
     }
  };

  const addDish = async () => {
    if (!newDish.name || !newDish.price || !newDish.category) return alert("Заполните поля!");
    
    const dishToSave = {
        name: capitalize(newDish.name),
        price: Number(newDish.price),
        weight: newDish.weight,
        category_name: newDish.category,
        image_url: null, 
        type: activeMenuType 
    };

    try {
        const { data, error } = await supabase.from('dishes').insert([dishToSave]).select();
        if (error) throw error;
        setDishes([...dishes, data[0]]);
        setNewDish({ ...newDish, name: "", weight: "", price: "", image: null });
        alert("Блюдо добавлено!");
    } catch (e) { alert("Ошибка: " + e.message); }
  };

  const handleDeleteDish = async (id) => {
      if(!window.confirm(t.deleteConfirm)) return;
      const { error } = await supabase.from('dishes').delete().eq('id', id);
      if(!error) setDishes(dishes.filter(d => d.id !== id));
  };

  const saveEditedDish = async () => {
      const { error } = await supabase.from('dishes').update({
          name: editingDish.name,
          price: editingDish.price,
          weight: editingDish.weight,
          category_name: editingDish.category_name,
      }).eq('id', editingDish.id);

      if (!error) {
          setDishes(dishes.map((d) => d.id === editingDish.id ? editingDish : d));
          setEditingDish(null);
      } else {
          alert("Ошибка обновления: " + error.message);
      }
  };
  
  const handleExport = () => {
    const dataToExport = { banquets, dishes, companyLogo, halls, categories, exportDate: new Date().toISOString() };
    const blob = new Blob([JSON.stringify(dataToExport)], { type: "application/json" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = `backup_${new Date().toISOString().slice(0,10)}.json`;
    link.click();
  };

  const filteredDishesByType = dishes.filter((d) => (d.type || "banquet") === activeMenuType);

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <h2>{t.manageDishes}</h2>
        <button style={{ ...styles.btn, ...styles.btnSecondary }} onClick={() => setView("list")}><ArrowLeft size={16} /> {t.back}</button>
      </div>

      <div style={{ ...styles.card, borderLeft: `4px solid #3b82f6`, marginBottom: '20px' }}>
        <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "15px" }}>
           <Settings size={20} color="#3b82f6" /> <h3 style={{ margin: 0 }}>{t.companyData}</h3>
        </div>
        <div style={{ display: "flex", flexDirection: isMobile ? "column" : "row", gap: "20px", alignItems: 'center' }}>
            <div style={{ display: "flex", alignItems: "center", gap: "15px" }}>
                <div style={{ width: "80px", height: "80px", background: styles.colors.inputBg, border: `1px dashed ${styles.colors.inputBorder}`, borderRadius: "8px", overflow: "hidden", display: "flex", alignItems: "center", justifyContent: "center" }}>
                  {companyLogo ? <img src={companyLogo} style={{ width: "100%", height: "100%", objectFit: "contain" }} alt="Logo" /> : <ImagePlus size={24} color={styles.colors.muted} />}
                </div>
                {/* Прячем кнопку загрузки логотипа для других компаний */}
                {/* <button style={{ ...styles.btn, ...styles.btnSecondary, padding: "8px" }} onClick={() => logoInputRef.current.click()}>Logo</button> */}
                {/* <input type="file" ref={logoInputRef} hidden accept="image/*" onChange={handleLogoUpload} /> */}
            </div>
            <div style={{ display: "flex", gap: "10px" }}>
                <button style={{ ...styles.btn, backgroundColor: "#16a34a", color: "white" }} onClick={handleExport}><Download size={16} /> {t.exportData}</button>
            </div>
        </div>
      </div>

      <div style={styles.glassCard}>
          <div style={styles.admin.accordionHeader} onClick={() => setShowHalls(!showHalls)}>
              <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                  <MapPin size={18} color="#10b981" /> <h3 style={{ margin: 0, fontWeight: 600, fontSize: '18px' }}>{t.manageHalls}</h3>
              </div>
              {showHalls ? <ChevronUp size={20} color="#94a3b8" /> : <ChevronDown size={20} color="#94a3b8" />}
          </div>
          {showHalls && (
            <div style={styles.admin.accordionContent}>
                <div style={styles.admin.inputGroup}>
                    <input type="text" value={newHallName} onChange={(e) => setNewHallName(capitalize(e.target.value))} placeholder={t.addHall} style={styles.admin.darkInput} />
                    <button onClick={addHall} style={styles.admin.addButton}><Plus size={20} /></button>
                </div>
                <div style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}>
                    {halls && halls.map((h) => (
                        <div key={h.id} style={styles.admin.hallChip}>
                            <span style={{marginRight: 8}}>{h.name}</span>
                            <div style={{ display: 'flex', gap: 5, paddingLeft: 8, borderLeft: '1px solid #475569' }}>
                                <button onClick={()=>deleteHall(h.id, h.name)} style={{background:'none', border:'none', cursor:'pointer', color:'#ef4444', padding:0}}><Trash2 size={14}/></button>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
          )}
      </div>

      <div style={{ display: "flex", gap: "10px", marginBottom: "20px" }}>
        <button onClick={() => setActiveMenuType("banquet")} style={{ ...styles.btn, ...(activeMenuType === "banquet" ? styles.btnPrimary : styles.btnSecondary), flex: 1 }}><Utensils size={16} /> {t.typeBanquet}</button>
        <button onClick={() => setActiveMenuType("buffet")} style={{ ...styles.btn, ...(activeMenuType === "buffet" ? styles.btnPrimary : styles.btnSecondary), flex: 1 }}><Coffee size={16} /> {t.typeBuffet}</button>
      </div>

      <div style={{ ...styles.card, marginBottom: "20px", borderLeft: `4px solid ${styles.colors.warning}` }}>
        <h4 style={{ marginTop: 0 }}>{t.addCategory}</h4>
        <div style={{ display: "flex", gap: "10px" }}>
            <input style={styles.input} placeholder={t.catNamePlaceholder || t.catPlaceholder} value={newCategoryName} onChange={(e) => setNewCategoryName(e.target.value)}/>
            <button onClick={handleAddCategory} style={{ ...styles.btn, ...styles.btnPrimary }}><Plus size={16} /> {t.save}</button>
        </div>
      </div>

      <div style={styles.card}>
        <h4>{t.addDish} ({activeMenuType === "banquet" ? t.typeBanquet : t.typeBuffet})</h4>
        <div style={{ marginBottom: "15px", display: "flex", alignItems: "center", gap: "15px" }}>
          <div style={{ width: "60px", height: "60px", borderRadius: "8px", background: styles.colors.inputBg, border: `1px dashed ${styles.colors.inputBorder}`, display: "flex", alignItems: "center", justifyContent: "center", overflow: "hidden" }}>
            <FileImage size={24} color={styles.colors.muted} />
          </div>
          <button style={{ ...styles.btn, ...styles.btnSecondary }} onClick={handlePhotoDisabled}><Camera size={16} /> {t.uploadPhoto}</button>
        </div>
        <div style={styles.mobileGrid}>
          <div style={{ width: "100%" }}>
              <select style={styles.select} value={newDish.category} onChange={(e) => setNewDish({...newDish, category: e.target.value})}>
                <option value="" disabled>{t.selectCategory}</option>
                {categories.map((c) => (<option key={c.id} value={c.name}>{c.name}</option>))}
              </select>
          </div>
          <input style={styles.input} placeholder={t.dishNamePlaceholder || t.dishName} value={newDish.name} onChange={(e) => setNewDish({...newDish, name: capitalize(e.target.value)})} />
          <input style={styles.input} placeholder={t.weightPlaceholder || t.weight} value={newDish.weight} onChange={(e) => setNewDish({...newDish, weight: e.target.value})} />
          <input type="number" style={styles.input} placeholder={t.pricePlaceholder || t.price} value={newDish.price} onChange={(e) => setNewDish({...newDish, price: e.target.value})} />
          <button style={{ ...styles.btn, ...styles.btnPrimary }} onClick={addDish}><Plus size={16} /> {t.addDish || t.add}</button>
        </div>
      </div>

      {editingDish && (
        <div style={styles.editor.modalOverlay}>
          <div style={styles.editor.modalContent}>
            <button onClick={() => setEditingDish(null)} style={{ position: "absolute", top: 10, right: 10, background: "none", border: "none", cursor: "pointer" }}><X size={24} color={styles.colors.text} /></button>
            <h3>{t.editDish}</h3>
            
            <div style={{ marginBottom: "15px", display: "flex", alignItems: "center", gap: "15px", justifyContent: "center" }}>
               <div style={{ width: "80px", height: "80px", borderRadius: "8px", background: styles.colors.inputBg, border: `1px dashed ${styles.colors.inputBorder}`, display: "flex", alignItems: "center", justifyContent: "center", overflow: "hidden" }}>
                {editingDish.image_url ? <img src={editingDish.image_url} style={{ width: "100%", height: "100%", objectFit: "cover" }} alt="" /> : <FileImage size={24} color={styles.colors.muted} />}
              </div>
              <button style={{ ...styles.btn, ...styles.btnSecondary }} onClick={handlePhotoDisabled}><Camera size={16} /> {t.uploadPhoto}</button>
            </div>

            <div style={{ display: "flex", flexDirection: "column", gap: "15px" }}>
              
              {/* --- НОВОЕ: Выбор категории --- */}
              <div>
                <label style={{ fontSize: "12px", color: styles.colors.muted, marginBottom: "5px", display: "block" }}>{t.category}</label>
                <select 
                    style={styles.select} 
                    value={editingDish.category_name || ""} 
                    onChange={(e) => setEditingDish({...editingDish, category_name: e.target.value})}
                >
                    {categories.map((c) => (<option key={c.id} value={c.name}>{c.name}</option>))}
                </select>
              </div>
              {/* ----------------------------- */}

              <div>
                <label style={{ fontSize: "12px", color: styles.colors.muted, marginBottom: "5px", display: "block" }}>{t.dishName}</label>
                <input style={styles.input} value={editingDish.name} onChange={(e) => setEditingDish({...editingDish, name: capitalize(e.target.value)})} />
              </div>
              <div>
                  <label style={{ fontSize: "12px", color: styles.colors.muted, marginBottom: "5px", display: "block" }}>{t.weight}</label>
                  <input style={styles.input} value={editingDish.weight} onChange={(e) => setEditingDish({...editingDish, weight: e.target.value})} />
              </div>
              <div>
                  <label style={{ fontSize: "12px", color: styles.colors.muted, marginBottom: "5px", display: "block" }}>{t.price}</label>
                  <input type="number" style={styles.input} value={editingDish.price} onChange={(e) => setEditingDish({...editingDish, price: e.target.value})} />
              </div>
              <button style={{ ...styles.btn, ...styles.btnSecondary, flex: 1 }} onClick={saveEditedDish}>{t.save}</button>
            </div>
          </div>
        </div>
      )}

      {/* Поиск и Список */}
      <div style={{ position: "relative", margin: "20px 0" }}>
        <Search size={16} style={{ position: "absolute", left: 10, top: 12, color: styles.colors.muted }} />
        <input style={{ ...styles.input, paddingLeft: 35 }} placeholder={t.searchMenuPlaceholder} value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} />
      </div>

      {categories.map((cat) => {
        const catDishes = filteredDishesByType.filter((d) => d.category_name === cat.name && d.name.toLowerCase().includes(searchTerm.toLowerCase())).sort((a, b) => a.name.localeCompare(b.name));
        if (catDishes.length === 0 && searchTerm.length > 0) return null; 
        
        return (
          <CategoryAccordion 
            key={cat.id} title={cat.name} count={catDishes.length} styles={styles} forceOpen={searchTerm.length > 0}
            action={<button onClick={(e) => { e.stopPropagation(); handleDeleteCategory(cat.id, cat.name); }} style={{ border: "none", background: "none", color: "#ef4444", cursor: "pointer" }}><Trash2 size={16} /></button>}
          >
            {catDishes.length > 0 ? (
                <table style={{ ...styles.table, margin: 0, tableLayout: "auto" }}>
                <tbody>
                    {catDishes.map((d) => (
                    <tr key={d.id}>
                        <td style={{ ...styles.td, width: 50, paddingLeft: 15 }}>
                        {d.image_url ? <img src={d.image_url} style={{ width: 30, height: 30, borderRadius: 4, objectFit: "cover" }} alt="" /> : <div style={{ width: 30, height: 30, background: styles.colors.inputBg, borderRadius: 4 }} />}
                        </td>
                        <td style={styles.td}><b>{d.name}</b></td>
                        <td style={styles.td}>{d.weight}</td>
                        <td style={styles.td}>{d.price}</td>
                        <td style={{ ...styles.td, textAlign: "right", paddingRight: 15 }}>
                        <button onClick={() => setEditingDish({ ...d })} style={{ border: "none", background: "none", color: "#3b82f6", marginRight: 10 }}><Edit size={16} /></button>
                        <button onClick={() => handleDeleteDish(d.id)} style={{ border: "none", background: "none", color: "#ef4444" }}><Trash2 size={16} /></button>
                        </td>
                    </tr>
                    ))}
                </tbody>
                </table>
            ) : <div style={{ padding: "10px", color: "#999", fontStyle: "italic", fontSize: "13px" }}>{t.noDishesInCat}</div>}
          </CategoryAccordion>
        );
      })}
    </div>
  );
};

export default AdminPanel;